import { useEffect } from "react";

function CookieConsent() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div
      className="elfsight-app-174fe816-72b9-4207-8d32-6e415ea446ad"
      data-elfsight-app-lazy
    ></div>
  );
}

export default CookieConsent;
